import React from "react";
import { useSelector } from "react-redux";
import ProgressLoader from "../../ProgressLoader";
import Translate from "./Translate";
import getFileFromType from "../Common/getFileFromType";
import { DocumentDownload } from "../../../../../assets/images";
import { formatBytes } from "../../../../../Helpers/Chat/ChatHelper";
import { captionLink } from "../../../../../Helpers/Utility";
import { getLocalUserDetails } from "../../../../../Helpers/Chat/User";
import { getExtension } from "../../../Common/FileUploadValidation";
import { useMessageProcessing } from "./useMessageProcessing";
import PropTypes from "prop-types";
const HtmlToReactParser = require('html-to-react').Parser;
const htmlToReactParser = new HtmlToReactParser();

const DocumentComponent = (props = {}) => {
  const { messageObject = {}, uploadStatus = 0, isSender, downloadAction, pageType } = props;
  const {
    msgId = "",
    msgBody: {
      translatedMessage = "",
      media: { fileName, file_size, file_url, file_key, caption = "" } = {},
      mentionedUsersIds = []
    } = {}
  } = messageObject;

  const {mediaDownloadData} = useSelector((state) => state);
  const vcardData = getLocalUserDetails();
  const fileExtension = getExtension(fileName);
  const placeholder = getFileFromType(null, fileExtension);
  const fileSize = formatBytes(file_size);
  const Extension = fileExtension.split(".").join("");

  const { messageRef } = useMessageProcessing({
    messageObject,
    isSender,
    vCardData: { data: vcardData || {} },
    htmlToReactParser
  });

  const isTranslated = () =>
    isSender && pageType === "conversation" && translatedMessage && Object.keys(translatedMessage).length;

  const isDownloading =
    msgId === mediaDownloadData?.downloadingStatus?.[msgId]?.downloadMediaMsgId &&
    mediaDownloadData?.downloadingStatus?.[msgId]?.downloading === true;
  const isInProgress = uploadStatus !== 2 || isDownloading;

  const triggerDownload = (e) => {
    if (isInProgress) return;
    downloadAction(e, file_url, fileName, file_key, msgId);
  };

  const handleBlockClick = (e) => {
    if (isInProgress) return;
    if (e?.target?.closest && e.target.closest('.doc-download, .file-details-download')) {
      return;
    }
    triggerDownload(e);
  };

  const handleBlockKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      triggerDownload(e);
    }
  };

  return (
    <>
      <div className="started_document_message">
        <div
          className={`document-message-block ${isInProgress ? "fileProgress" : ""}
            ${Extension === "pdf" || Extension === "ppt" ? "fileThumb" : ""}`}
          onClick={handleBlockClick}
          onKeyDown={handleBlockKeyDown}
          role="button"
          tabIndex={isInProgress ? -1 : 0}
          style={{ cursor: isInProgress ? "default" : "pointer" }}
        >
            <i className="doc">
              <img alt="file" src={placeholder} />
            </i>
            <span className="doc_name">
              <span>{fileName}</span>
            </span>
            <i className="doc-download" onClick={(e) => downloadAction(e, file_url, fileName, file_key, msgId)}
            onKeyDown={(e) => e.key === 'Enter' && downloadAction(e, file_url, fileName, file_key, msgId)}
            tabIndex="0"
            role="button"
            >
              <DocumentDownload />
            </i>
            <ProgressLoader
              msgId={msgId}
              isSender={isSender}
              uploadStatus={uploadStatus}
              imgFileDownloadOnclick={() => {
              }}
            />
        </div>
        <span className="file-details">
          <span>{fileSize}{" "}-{" "}{Extension}</span>
          <i
            className="file-details-download"
            onClick={(e) => downloadAction(e, file_url, fileName, file_key, msgId)}
            onKeyDown={(e) => e.key === 'Enter' && downloadAction(e, file_url, fileName, file_key, msgId)}
            tabIndex="0"
            role="button"
            title="Download file"
          >
            <DocumentDownload />
          </i>
        </span>
      </div>
      <div className="image-caption" ref={messageRef}>
        {caption !== "" && (
          <span>
            <span>{captionLink(caption, mentionedUsersIds, vcardData.userId, messageObject.chatType)}</span>
            {!!isTranslated() && <Translate tMessage={translatedMessage} />}
          </span>
        )}
      </div>
    </>
  );
};

export default DocumentComponent;

DocumentComponent.propTypes = {
  messageObject: PropTypes.shape({
    msgId: PropTypes.string,
    msgBody: PropTypes.shape({
      media: PropTypes.shape({
        fileName: PropTypes.string,
        file_size: PropTypes.number,
        file_url: PropTypes.string,
        file_key: PropTypes.string,
        caption: PropTypes.string,
      }),
    }),
  }),
  uploadStatus: PropTypes.number,
  isSender: PropTypes.bool,
  downloadAction: PropTypes.func,
  pageType: PropTypes.string,
};